import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ProductSection from "./components/ProductSection";
import PhygitalSection from "./components/PhygitalSection";
import WellnessSection from "./components/WellnessSection";
import PricingSection from "./components/PricingSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";
import TermsAndConditions from "./components/TermsAndConditions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import DataDeletionForm from "./components/DataDeletionForm";

function LandingPage() {
  return (
    <div className="min-h-screen bg-[#050505] text-white relative noise-overlay">
      <Header />
      <main>
        <HeroSection />
        <ProductSection />
        <PhygitalSection />
        <WellnessSection />
        <PricingSection />
        <TestimonialsSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/terminos" element={<TermsAndConditions />} />
        <Route path="/privacidad" element={<PrivacyPolicy />} />
        <Route path="/eliminar-cuenta" element={<DataDeletionForm />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
